import { gql } from '@apollo/client';
import {
  SAVED_VIEW_BASE_FRAGMENT,
  SAVED_VIEW_DETAIL_FRAGMENT,
  SAVED_VIEW_FRAGMENT,
  SAVED_VIEW_METADATA_FRAGMENT,
  SAVED_VIEW_RELATED_FRAGMENT,
  SavedView,
  SavedViewResponse,
  SavedViewRole,
  SavedViewUser,
} from './savedViewFragments';

export type SavedViewArgs = {
  id: SavedView['id'];
};

export type SavedViewResponseData = {
  savedView: SavedViewResponse;
};

export type SavedViewsArgs = {
  filter?: Pick<SavedView, 'app'> & Pick<Partial<SavedView>, 'id' | 'appVersion' | 'name'> & {
    roleId?: SavedViewRole['roleId'];
    userId?: SavedViewUser['userId']
  };
  includeMetadata?: boolean;
  includeDetails?: boolean;
  includeRelated?: boolean;
}

export type SavedViewsResponseData = {
  savedViews: SavedViewResponse[];
};

export const SAVED_VIEW_QUERY = gql`
  query SavedViewQuery($id: String!) {
    savedView(id: $id) {
      ...SavedViewFragment
    }
  }
  ${SAVED_VIEW_FRAGMENT}
`;

export const SAVED_VIEWS_QUERY = gql`
  query SavedViewsQuery(
    $filter: SavedViewsFilter
    $includeMetadata: Boolean! = false
    $includeDetails: Boolean! = false
    $includeRelated: Boolean! = false
  ) {
    savedViews(
      filter: $filter
    ) {
      ...SavedViewBaseFragment
      ...SavedViewMetadataFragment  @include(if: $includeMetadata)
      ...SavedViewDetailFragment    @include(if: $includeDetails)
      ...SavedViewRelatedFragment   @include(if: $includeRelated)
    }
  }
  ${SAVED_VIEW_BASE_FRAGMENT}
  ${SAVED_VIEW_DETAIL_FRAGMENT}
  ${SAVED_VIEW_METADATA_FRAGMENT}
  ${SAVED_VIEW_RELATED_FRAGMENT}
`;
